import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreFieldsText: {
		id: 'issue-view-layout-templates-views.context.visible-hidden.more-fields-text',
		defaultMessage: 'More fields',
		description: 'Show more fields in context',
	},
	// TODO: When cleaning up isSortingPinnedFieldsEnabled remove pinnedFieldsText
	pinnedFieldsText: {
		id: 'issue-view-layout-templates-views.context.visible-hidden.pinned-fields-text',
		defaultMessage: 'Pinned fields',
		description: 'Show pinned fields in context',
	},
	pinnedFieldsTitle: {
		id: 'issue-view-layout-templates-views.context.visible-hidden.pinned-fields-title',
		defaultMessage: 'Your pinned fields',
		description: 'Show pinned fields in context',
	},
	detailsText: {
		id: 'issue-view-layout-templates-views.context.visible-hidden.details-text',
		defaultMessage: 'Details',
		description: 'Details Group in Context',
	},
});
